module.exports = __webpack_public_path__ + "img/place-24px.fb271810.svg";